import styled from 'styled-components';
import { mx, mb } from 'styled-components-spacing';
import breakpoint from 'styled-components-breakpoint';

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;

export const BannerContainer = styled.div`
  max-width: 900px;
  margin: auto;
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;

  @media (min-width: 640px) {
    padding: 1rem;
  }
  @media (max-width: 736px) {
    max-width: 650px;
  }
  @media (min-width: 736px) and (max-width: 1024px){
    max-width: 800px;
  }
`;

export const BannerCard = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
  width: 100%;
  overflow: hidden;
  svg{
    height: 20px;
    width: 20px;
  }
  ${breakpoint('mobile', 'desktop')`
    width: 100%;
    position:absolute;
    height: 15px;
    svg{
      height: 15px;
      width: 15px;
    }
    z-index: 1000;
  `}
  :hover{
    cursor: pointer;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  z-index: 10;
  height: 2rem;
  width: 2rem;
  padding: 0;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  color: #333;

  &:hover {
    background-color: #f3f4f6;
  }

  @media (min-width: 640px) {
    top: 1rem;
    right: 1rem;
  }
`;

export const BannerContent = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 400px;
  border-radius: 20px;
  border: 2px solid white;
  overflow: hidden;
  @media (min-width: 1024px) {
    flex-direction: row;
    min-height: 500px;
    max-height: 650px;
  }
  ${breakpoint('mobile', 'tablet')`
    border-radius: 5px;
    overflow-y: scroll;
    min-height: 350px;
    ${({ form }) => (form === 'Sign up Form' && `
      height: 100%;
      max-height: 850px;
      justify-content: flex-start;
    `)}
  `}

  @media (min-width: 736px) and (max-width: 1024px){
    flex-direction: column;
    border-radius: 10px;
    height: 100%;
    min-height: 350px;
    max-height: 950px;
    overflow-y: scroll;
  }
`;

export const ImageContainer = styled.div`
  position: relative;

  @media (min-width: 1024px) {
     width: 55%;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
  ${breakpoint('mobile', 'desktop')`
    height: 50%;
  `}
  @media (min-width: 736px) and (max-width: 1024px){
     ${({ form }) => (form === 'Sign up Form' ? `
    height: 45%;
    ` : `
    height: 80vh;
    max-height: 80vh;
    overflow: hidden;
    display: flex;
   `)}
    }
`;

export const ImageOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.6), transparent, transparent);
`;

export const ImageText = styled.p`
  position: absolute;
  bottom: 0.75rem;
  ${mx(3)};
  color: white;
  line-height: 1.2;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 0.25rem;
  padding: 10px;
  border-radius: 10px;


  ${breakpoint('mobile', 'tablet')`
    font-size: 18px;
    padding: 0px;
    border-radius: 5px;
    line-height: 1.2;
    margin-left: 0.5rem;
  `}
  /* @media (min-width: 736px) and (max-width: 1024px){
    h2{
      font-size: 20px;
      font-weight: 600;
    }
  } */
`;

export const ContentContainer = styled.div`
  width: 100%;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  background-color:  #f5f5f5;;
  align-content: flex-end;
  flex:1;
  justify-content: space-between;
  @media (min-width: 640px) {
    padding: 1.5rem;
  }

  @media (min-width: 1024px) {
    width: 50%;
    overflow: auto;
    padding: 2rem;
  }
  ${breakpoint('mobile', 'tablet')`
    padding: 5px 10px;
    width: auto;
    ${({ form }) => (form === 'Sign up Form' ? `
    justify-content: space-evenly;
  ` : `
    justify-content: space-start;
  `)}
  `}
  @media (min-width: 736px) and (max-width: 1024px){
     width: auto;
    justify-content: space-between;
  }
`;


export const TextContentHeading = styled.h2`
  margin-bottom: 1rem;
  font-size: 25px;
  font-weight: bold;
  color: #111827;
  margin-bottom: 0.5rem;
  font-weight: 700;
  line-height: 1.4;
  ${breakpoint('mobile', 'desktop')`
    font-size: 21px;
    margin-bottom: 5px;
  `}
`;

export const TextContentSubHeading = styled.p`
  margin-bottom: 1rem;
  color: #4b556391;
  font-weight: 600;
  font-size: 18px;
  line-height: 1.2;
  ${breakpoint('mobile', 'desktop')`
    font-size: 17px;
    margin-bottom: 5px;
    line-height: 1.5;
  `}
`;

export const FormContainer = styled.div`
  width: 100%;
`;

export const RedirectContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  font-size: 13px;
  line-height: 1.4;
  color: grey;
  align-items: center;
  p {
    color: #4b5563;
    font-size: 0.875rem;
  }

  @media (min-width: 640px) {
    gap: 1rem;

    p {
      font-size: 1rem;
    }
  }
  ${breakpoint('mobile', 'tablet')`
    ${mb(2)}
    font-size: 13px;
    line-height: 1.2;
    align-items: center;
  `}
  ${breakpoint('tablet', 'desktop')`
    font-size: 14px;
  `}
`;

export const RedirectButton = styled.button`
  width: 100%;
  background: linear-gradient(118.6deg, rgb(99, 174, 207) 0%, rgb(98, 158, 206) 30.63%, rgb(69, 143, 211) 63.31%, rgb(58, 120, 177) 98.02%);
  color: white;
  font-weight: 600;
  padding: 10px 12px;
  border-radius: 0.5rem;
  transition: all 0.2s;
  font-size: 20px;
  border: none;
  cursor: pointer;

  ${breakpoint('mobile', 'desktop')`
    font-size: 17px;
  `}
`;

export const StyledDiv = styled.div``;
